import { MapLocalizationToProps, MapLocKey, withLocalization } from "UI/UI.React/HOC";
import { DropdownCaptionItemComponent, DropdownCaptionItemComponentProps } from "../DropdownCaptionItemComponent";

export type DropdownCaptionItemProps = {
    readonly locKey: string;
} & DropdownCaptionItemComponentProps;

type StateProps = Pick<DropdownCaptionItemComponentProps, "text">;

const mapToProps: MapLocalizationToProps<StateProps> = ({ text }) => ({
    text,
});

const mapLocKeyProp: MapLocKey<Omit<DropdownCaptionItemProps, "text">> = ({ locKey }) => ({
    locKey,
});

export const DropdownCaptionItem = withLocalization(mapToProps, mapLocKeyProp)(DropdownCaptionItemComponent);
